import { HttpClient, robotoHeaders } from "../../http";

import { OrgInviteRecord } from "./InviteRecord";

export class InviteService {
  #httpClient: HttpClient;

  constructor(httpClient: HttpClient) {
    this.#httpClient = httpClient;
  }

  public async getInvite(
    inviteId: string,
    abortSignal?: AbortSignal,
  ): Promise<OrgInviteRecord> {
    const requestUrl = this.#httpClient.constructUrl(
      `v1/orgs/invites/${inviteId}`,
    );

    const response = await this.#httpClient.get(requestUrl, {
      headers: robotoHeaders({}),
      signal: abortSignal,
    });

    return response.json<OrgInviteRecord>();
  }

  public async acceptInvite(inviteId: string): Promise<void> {
    const requestUrl = this.#httpClient.constructUrl(
      `v1/orgs/invites/${inviteId}/accept`,
    );

    const response = await this.#httpClient.post(requestUrl, {
      headers: robotoHeaders({}),
    });

    await response.throwIfError();
  }

  public async declineInvite(inviteId: string): Promise<void> {
    const requestUrl = this.#httpClient.constructUrl(
      `v1/orgs/invites/${inviteId}/decline`,
    );

    const response = await this.#httpClient.post(requestUrl, {
      headers: robotoHeaders({}),
    });

    await response.throwIfError();
  }
}
